export default "__VITE_ASSET__B1jvo53B__"